import { Paper } from "@mui/material";
import React from "react";
import { shallowEqual, useSelector } from "react-redux";
import { MAIN_LABEL } from "../../../app/modules/coinWrap/Helpers/Common/CommonComponent";
import DashbaordChart from "./DashbaordChart";

export function Dashboard() {
  const { RolesAndPermissions, currentUser } = useSelector(
    (state) => ({
      RolesAndPermissions: state.rolesAndPermissions.allRolesAndPermissions,
      currentUser: state.rolesAndPermissions.userDetails,
    }),
    shallowEqual
  );

  return (
    <>
      {
        RolesAndPermissions[MAIN_LABEL.DASHBOARD] &&
          RolesAndPermissions[MAIN_LABEL.DASHBOARD].length ?
          <DashbaordChart /> :
          <Paper sx={{ height: "100%", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center" }}>
            <div
              className=" font-weight-boldest text-dark-50"
              style={{ fontSize: "3.3rem" }}
            >
              Welcome to Coinwrap, {currentUser?.firstName}
            </div>
          </Paper>
      }
    </>
  );
}
